import { styled } from "styled-components";

export const Separator = styled.div<{ height?: number }>`
  background-color: ${({ theme }) => theme.colors.separator};
  padding: ${({ height = 2 }) => height / 2}px 0;
  width: 100%;
`;
